<template>
    <div>
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :disabled="blockEdit || statusIsFinalizado"
                    :options="form.prestadores"
                    :validations="validations.prestadorId"
                    label="Prestador"
                    show-default-option
                    text-field="nomeUnidade"
                    v-model="model.prestadorId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col v-if="additionals.isAgendamentoProgramado" cols="2">
                <rkm-form-date-picker
                    :disabled="blockEdit || statusIsFinalizado"
                    :validations="validations.dataAgendamento"
                    label="Data agendamento"
                    right
                    v-model="formattedData"
                />
            </rkm-col>

            <rkm-col v-if="additionals.isCusto" cols="2">
                <rkm-form-input
                    :disabled="blockEdit || statusIsFinalizado"
                    :validations="validations.custo"
                    label="Custo"
                    prepend="R$"
                    v-model="model.custo"
                    v-money="money"
                />
            </rkm-col>

            <rkm-col v-if="additionals.isIdentificaOsPrestador" cols="2">
                <rkm-form-input
                    :disabled="blockEdit || statusIsFinalizado"
                    :validations="validations.osPrestador"
                    label="Número OS"
                    v-model="model.osPrestador"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="additionals.isIdentificaItensAlmoxarifado">
            <rkm-col>
                <rkm-area
                    no-margin-top
                    title="Itens do almoxarifado"
                    type="fieldset"
                >

                <form-itens-almoxarifado
                    ref="formItensAlmoxarifado"
                    :model="model"
                    :form="form"
                />

                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-area
            no-margin-top
            title="Comentários"
            type="fieldset"
        >
            <template slot="trailing">
                <rkm-button
                    @click="visible = !visible"
                    color="primary"
                    small
                >
                    <rkm-icon :icon="visible ? 'angle-double-up' : 'angle-double-down'" />
                </rkm-button>
            </template>
            <rkm-collapse :visible="visible">
                <rkm-row>
                    <rkm-col>
                        <rkm-row v-if="form.statusTipoId !== enums.statusTipo.CANCELADO && form.statusTipoId !== enums.statusTipo.FINALIZADO">
                            <rkm-col>
                                <rkm-form-textarea
                                    :disabled="!isLastMessageResponded || blockEdit"
                                    :label="novoComentarioLabel"
                                    :validations="validations.mensagemAtual"
                                    class="mb-2"
                                    v-model="model.comentarioAtual"
                                />
                            </rkm-col>
                        </rkm-row>

                        <div v-if="form.mensagensReposposta">
                            <div v-for="(mensagem, index) in form.mensagensReposposta" :key="index">
                                <rkm-row>
                                    <rkm-col>
                                        <rkm-form-textarea
                                            :readonly="true"
                                            class="mb-2"
                                            label="Mensagem"
                                            v-model="mensagem.mensagem.mensagem"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col class="d-flex justify-content-end">
                                        <small>
                                            <em>Data: {{ mensagem.mensagem.data }}</em>&nbsp;&nbsp;
                                            <em>Hora: {{ mensagem.mensagem.hora }}</em>&nbsp;&nbsp;
                                            <em>Usuário: {{ mensagem.mensagem.nomeUsuario }}</em>
                                        </small>
                                    </rkm-col>
                                </rkm-row>
                                <hr class="mt-1 mb-1">

                                <rkm-row>
                                    <rkm-col>
                                        <rkm-form-textarea
                                            v-if="mensagem.resposta"
                                            :readonly="mensagem.resposta ? true : false"
                                            :value="mensagem.resposta ? mensagem.resposta.mensagem : ''"
                                            class="mb-2"
                                            label="Resposta"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col class="d-flex justify-content-end">
                                        <small v-if="mensagem.resposta">
                                            <em>Data: {{ mensagem.resposta.data }}</em>&nbsp;&nbsp;
                                            <em>Hora: {{ mensagem.resposta.hora }}</em>&nbsp;&nbsp;
                                            <em>Usuário: {{ mensagem.resposta.nomeUsuario }}</em>
                                        </small>
                                    </rkm-col>
                                </rkm-row>
                                <hr v-if="mensagem.resposta" class="mt-1 mb-1">
                            </div>
                        </div>

                    </rkm-col>
                </rkm-row>
            </rkm-collapse>
        </rkm-area>
    </div>
</template>
<script>

// Components.
import formItensAlmoxarifado from './components/itens-almoxarifado/Index'

// Mixin.
import { repository } from '@/mixins'

//Directives
import { VMoney } from 'v-money'

// Enums.
import statusTipo from '@/enums/manutencao/statusTipo'

export default {
    components: { formItensAlmoxarifado },
    directives: { money: VMoney },
    computed: {
        validations() {
            return {
                prestadorId: {
                    required: true,
                },
                dataAgendamento: {
                    required: false,
                },
                custo: {
                    max: 10,
                    required: false,
                },
                osPrestador: {
                    max: 10,
                    required: false,
                },
                mensagemAtual: {
                    max: 500,
                }
            }
        },
        isLastMessageResponded() {
            if (!this.form.mensagensReposposta || this.form.mensagensReposposta.length === 0) {
                return true;
            }
            const lastMessage = this.form.mensagensReposposta[this.form.mensagensReposposta.length - 1];
            return !!lastMessage.resposta;
        },
        novoComentarioLabel() {
            return this.isLastMessageResponded
                ? 'Novo comentário'
                : 'Novo comentário (aguarde a resposta da última mensagem enviada)';
        },
        formattedData: {
            get() {

                if (!this.model.dataAgendamento) {

                    return null;
                }
                const [day, month, year] = this.model.dataAgendamento.split('/');
                return `${year}-${month}-${day}`;
            },
            set(newValue) {

                if (newValue) {

                    const year = newValue.getFullYear();
                    const month = String(newValue.getMonth() + 1).padStart(2, '0');
                    const day = String(newValue.getDate()).padStart(2, '0');

                    this.model.dataAgendamento = `${day}/${month}/${year}`;
                }
            }
        },
        statusIsFinalizado() {

            return this.form.pedenteFinalizacao || this.form.statusTipoId === this.enums.statusTipo.CANCELADO;
        }
    },
    data: () => ({
        visible: false,
        money: {
            decimal: ',',
            masked: false,
            precision: 2,
            suffix: '',
            thousands: '.',
        },
        enums: { statusTipo }
    }),
    mixins: [ repository ],
    props: {
        additionals: {type: [Object, Array], required: true, default: () => ({})},
        model: {type: [Object, Array], required: true, default: () => ({})},
        form: {type: [Object, Array], required: true, default: () => ({})},
        blockEdit: {type: Boolean, required: false, default: false},
    }
}
</script>